import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {CustomMenuItem} from '../../components/common/arr-menu/ArrMenu';

interface ActionButtonState {
  selectedActionMenu: CustomMenuItem;
  isActionSelected: boolean;
}

const initialState: ActionButtonState = {
  selectedActionMenu: {label: '', id: ''},
  isActionSelected: false,
};

export const ActionButtonSlice = createSlice({
  name: 'actionButton',
  initialState,
  reducers: {
    setSelectedAction(state, action: PayloadAction<CustomMenuItem>) {
      state.selectedActionMenu = action.payload;
      state.isActionSelected = true;
    },
    clearSelectedAction() {
      return initialState;
    },
  },
});

export const {setSelectedAction, clearSelectedAction} =
  ActionButtonSlice.actions;
export default ActionButtonSlice.reducer;
